export default __webpack_public_path__ + "assets/1cb393fbc5a521ccfb3e6eb8783c3b81/09.jpg";